import { Sparkle } from "lucide-react";
import { MARQUEE_ITEMS } from "../config/site";

export default function Marquee() {
  const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      className="relative overflow-hidden border-y border-white/[0.07] bg-[#07080f] py-5"
      data-testid="editorial-marquee"
      aria-hidden="true"
    >
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-[#05060a] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-[#05060a] to-transparent" />
      <div className="flex w-max animate-marquee items-center gap-10 pr-10">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="whitespace-nowrap font-mono text-[12px] font-medium uppercase tracking-[0.32em] text-slate-400">
              {item}
            </span>
            <Sparkle className="h-3.5 w-3.5 shrink-0 text-indigo-400/70" />
          </span>
        ))}
      </div>
    </div>
  );
}
